import axios from "@/hooks/axios/axios";
import type {
  IClientAddPayload,
  IClientAddResponse,
} from "../types/client-add.types";
import type {
  IClientEditPayload,
  IClientEditResponse,
} from "../types/client.types";

export const addClient = async (
  payload: IClientAddPayload,
): Promise<IClientAddResponse> => {
  const { data } = await axios.post("/users/add", payload);
  return data;
};

export const editClient = async (
  userId: string,
  payload: IClientEditPayload,
): Promise<IClientEditResponse> => {
  const { data } = await axios.put(`/users/${userId}`, payload);
  return data;
};
